import { render, staticRenderFns } from "./InviteView.vue?vue&type=template&id=6dd9e96d&"
import script from "./InviteView.vue?vue&type=script&lang=ts&"
export * from "./InviteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports